/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const searchRpc = {
  serviceName: 'com.hubspot.learning.center.search.no.auth.rpc.PublicSearchService',
  rpcName: 'search',
  auth: 'external',
  fingerprint: 'nNyD99hcDXCRutRvxTgRBBLuLWvMCU-G'
};